import React, { useState, useEffect, useRef } from "react";
import { fetchVulnerabilitySummary } from "../../../../../utils/axios";
import VulnerabilityChartDisplay from "./VulnerabilityChartDisplay";
import VulnerabilityChartSelector from "./VulnerabilityChartSelector";

function VulnerabilityChartDashboard() {
  const [chartType, setChartType] = useState("line");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const chartRef = useRef(null);

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await fetchVulnerabilitySummary();
      setData(result);
    } catch (err) {
      setError(err.message || "Failed to fetch vulnerability data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData(); // Load on mount
  }, []);

  const handleChartChange = (type) => {
    setChartType(type);
  };

  const handleDownload = (format) => {
    if (chartRef.current && chartRef.current.downloadChart) {
      chartRef.current.downloadChart(format);
    }
  };

  return (
    <div className="card-body">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
        {/* <div>
          <h6 className="card-subtitle mb-2 text-muted fw-semibold">Vulnerability by Severity</h6>
        </div> */}
        <div className="d-flex mt-md-0">
          <VulnerabilityChartSelector
            currentChart={chartType}
            onChartChange={handleChartChange}
            onDownload={handleDownload}
            onRefresh={loadData}
          />
        </div>
      </div>

      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "300px" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : error ? (
        <div className="alert alert-danger" role="alert">
          <strong>Error:</strong> {error}
        </div>
      ) : (
        // <div
        //   className="chart-wrapper position-relative"
        //   style={{ width: "100%", overflowX: "auto", height: "384px" }}
        // >
        <div>
          <VulnerabilityChartDisplay
            ref={chartRef}
            chartType={chartType}
            data={data}
          />
        </div>
        // </div>
      )}
    </div>
    // <div className="min-h-screen bg-gray-100 p-4 md:p-8">
    //   <div className="max-w-7xl mx-auto">
    //     <div className="bg-white rounded-lg shadow-md p-4 md:p-6 mb-8">
    //       <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
    //         <div className="mt-4 md:mt-0">
    //           <VulnerabilityChartSelector
    //             currentChart={chartType}
    //             onChartChange={handleChartChange}
    //             onDownload={handleDownload}
    //             onRefresh={loadData}
    //           />
    //         </div>
    //       </div>

    //       {loading ? (
    //         <div className="flex justify-center items-center h-80">
    //           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
    //         </div>
    //       ) : error ? (
    //         <div
    //           className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative"
    //           role="alert"
    //         >
    //           <strong className="font-bold">Error: </strong>
    //           <span className="block sm:inline">{error}</span>
    //         </div>
    //       ) : (
    //         <VulnerabilityChartDisplay
    //           ref={chartRef}
    //           chartType={chartType}
    //           data={data}
    //         />
    //       )}
    //     </div>
    //   </div>
    // </div>
  );
}

export default VulnerabilityChartDashboard;
